// src/locales/ta.js
import { auth } from "./ta/auth";
import { business } from "./ta/business";
import { common } from "./ta/common";
import { dashboard } from "./ta/dashboard";
import { errors } from "./ta/errors";
import { footer } from "./ta/footer";
import { forms } from "./ta/forms";
import { header } from "./ta/header";
import { language } from "./ta/language";
import { nav } from "./ta/nav";
import { orders } from "./ta/orders";
import { ecomOrders } from './ta/ecomOrders';
import { orderAssignment } from './ta/orderAssignment';
import { products } from "./ta/products";
import { productTags } from './ta/productTags';
import { attributes } from './ta/attributes';
import { categories } from './ta/categories';
import { brands } from './ta/brands';
import { shops } from "./ta/shops";
import { sidebar } from "./ta/sidebar";
import { userRoles } from "./ta/userRoles";
import { users } from "./ta/users";
import { warehouses } from "./ta/warehouses";
import { couriers } from './ta/couriers';
import { packingBatch, courierUpload, dispatch, print } from './ta/packingBatch';
import { returnBatch } from './ta/returnBatch';
import { courierInvoice } from './ta/courierInvoice';
import { purchaseOrder } from './ta/purchaseOrder';
import { stockAdjustment } from './ta/stockAdjustment';
import { stockTransfer } from './ta/stockTransfer';
import { report } from './ta/report';
import { supplier } from './ta/supplier';
import { phoneBlacklist } from './ta/phoneBlacklist';
import { dropshipping } from './en/dropshipping';
import { profile } from './en/profile';
import { pos } from './ta/pos';
import { expenses } from './ta/expenses';
import { leadAutomation } from './ta/leadAutomation';
import { messageCenterShifts } from './ta/messageCenterShifts';
import { messageCenterShiftTypes } from './ta/messageCenterShiftTypes';
import { messageCenterCommission } from './ta/messageCenterCommission';
import { messageCenterShiftLeaderCommission } from './ta/messageCenterShiftLeaderCommission';
import { paymentVerification } from './ta/paymentVerification';
import { callCenterShifts } from './ta/callCenterShifts';
import { callCenterCommission } from './ta/callCenterCommission';
import { storePickup } from './ta/storePickup';
import { creditNote } from './ta/creditNote';
import { quotation } from './ta/quotation';
import { deliveryNote } from './ta/deliveryNote';
import { returnNote } from './ta/returnNote';
import { goodsReceivedNote } from './ta/goodsReceivedNote';
import { returnToVendor } from './ta/returnToVendor';
import { debitNote } from './ta/debitNote';
import { procurement } from './ta/procurement';
// No ta translation yet (parity gap, see AGENTS.md) — alias to en until authored.
import { offlineSales } from './ta/offlineSales';

export default {
  common: common,
  nav: nav,
  auth: auth,
  dashboard: dashboard,
  header: header,
  sidebar: sidebar,
  userRoles: userRoles,
  users: users,
  shops: shops,
  warehouses: warehouses,
  orders: orders,
  ecomOrders: ecomOrders,
  orderAssignment: orderAssignment,
  products: products,
  productTags: productTags,
  attributes: attributes,
  categories: categories,
  brands: brands,
  forms: forms,
  errors: errors,
  footer: footer,
  language: language,
  business: business,
  returnBatch: returnBatch,
  courierInvoice: courierInvoice,
  couriers: couriers,
  packingBatch: packingBatch,
  dispatch:dispatch,
  print:print,
  courierUpload: courierUpload,
  purchaseOrder: purchaseOrder,
  stockAdjustment: stockAdjustment,
  stockTransfer: stockTransfer,
  report:report,
  supplier:supplier,
  phoneBlacklist:phoneBlacklist,
  dropshipping: dropshipping,
  pos: pos,
  expenses: expenses,
  profile: profile,
  leadAutomation: leadAutomation,
  messageCenterShifts: messageCenterShifts,
  messageCenterShiftTypes: messageCenterShiftTypes,
  messageCenterCommission: messageCenterCommission,
  messageCenterShiftLeaderCommission: messageCenterShiftLeaderCommission,
  callCenterShifts: callCenterShifts,
  callCenterCommission: callCenterCommission,
  paymentVerification: paymentVerification,
  callCenterShifts: callCenterShifts,
  callCenterCommission: callCenterCommission,
  storePickup: storePickup,
  offlineSales: offlineSales,
  creditNote: creditNote,
  quotation: quotation,
  deliveryNote: deliveryNote,
  returnNote: returnNote,
  goodsReceivedNote: goodsReceivedNote,
  returnToVendor: returnToVendor,
  debitNote: debitNote,
  procurement: procurement,
};